module.exports = __webpack_public_path__ + "static/media/playlist-remove.39f1b28a.svg";